export default __webpack_public_path__ + "static/media/bruno-ballester.0e9f81a5.png";